module.exports = __webpack_public_path__ + "img/eyeclose.a7fe648c.svg";